"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FluidIconKey = void 0;
var FluidIconKey;
(function (FluidIconKey) {
    FluidIconKey["AI_BADGE"] = "ai_badge";
    FluidIconKey["AI_SPARK"] = "ai_spark";
    FluidIconKey["ARROW_DOWN"] = "arrow_down";
    FluidIconKey["ARROW_LEFT"] = "arrow_left";
    FluidIconKey["ARROW_RIGHT"] = "arrow_right";
    FluidIconKey["ARROW_UP"] = "arrow_up";
    FluidIconKey["ATTACHMENT"] = "attachment";
    FluidIconKey["BACK"] = "back";
    FluidIconKey["BARS"] = "bars";
    FluidIconKey["BULLHORN"] = "bullhorn";
    FluidIconKey["CALCULATOR"] = "calculator";
    FluidIconKey["CALENDAR"] = "calendar";
    FluidIconKey["CAMERA"] = "camera";
    FluidIconKey["CARET_DOWN"] = "caret_down";
    FluidIconKey["CARET_LEFT"] = "caret_left";
    FluidIconKey["CARET_RIGHT"] = "caret_right";
    FluidIconKey["CARET_UP"] = "caret_up";
    FluidIconKey["CHECK"] = "check";
    FluidIconKey["CHECK_CIRCLE"] = "check_circle";
    FluidIconKey["CHECK_CIRCLE_O"] = "check_circle_o";
    FluidIconKey["CHEVRON_DOWN"] = "chevron_down";
    FluidIconKey["CHEVRON_LEFT"] = "chevron_left";
    FluidIconKey["CHEVRON_RIGHT"] = "chevron_right";
    FluidIconKey["CHEVRON_UP"] = "chevron_up";
    FluidIconKey["CIRCLE_O"] = "circle_o";
    FluidIconKey["CODE"] = "code";
    FluidIconKey["COLLAPSE"] = "collapse";
    FluidIconKey["COLLAPSE_LEFT"] = "collapse_left";
    FluidIconKey["COLLAPSE_RIGHT"] = "collapse_right";
    FluidIconKey["COMMENT_QUESTION"] = "comment_question";
    FluidIconKey["COMMENTS"] = "comments";
    FluidIconKey["COPY"] = "copy";
    FluidIconKey["DELETE"] = "delete";
    FluidIconKey["DISMISS"] = "dismiss";
    FluidIconKey["DOCUMENT"] = "document";
    FluidIconKey["DOCUMENT_MULTI"] = "document_multi";
    FluidIconKey["DOLLAR"] = "dollar";
    FluidIconKey["DOWNLOAD"] = "download";
    FluidIconKey["EDIT"] = "edit";
    FluidIconKey["ELLIPSIS_VERTICAL"] = "ellipsis_vertical";
    FluidIconKey["EMAIL"] = "email";
    FluidIconKey["EMAIL_SOLID"] = "email_solid";
    FluidIconKey["ERROR"] = "error";
    FluidIconKey["EXPAND"] = "expand";
    FluidIconKey["EXPAND_LEFT"] = "expand_left";
    FluidIconKey["EXPAND_RIGHT"] = "expand_right";
    FluidIconKey["EXTERNAL_LINK"] = "external_link";
    FluidIconKey["FACE_HAPPY"] = "face_happy";
    FluidIconKey["FACE_NEUTRAL"] = "face_neutral";
    FluidIconKey["FACE_SAD"] = "face_sad";
    FluidIconKey["FACE_VERY_HAPPY"] = "face_very_happy";
    FluidIconKey["FACE_VERY_SAD"] = "face_very_sad";
    FluidIconKey["FILE"] = "file";
    FluidIconKey["FILE_ALT"] = "file_alt";
    FluidIconKey["FILTER"] = "filter";
    FluidIconKey["FLAG"] = "flag";
    FluidIconKey["FLUID"] = "FLUID";
    FluidIconKey["FOLDER"] = "folder";
    FluidIconKey["FOLDER_OPEN"] = "folder_open";
    FluidIconKey["FORM"] = "form";
    FluidIconKey["FORWARD"] = "forward";
    FluidIconKey["GAVEL"] = "gavel";
    FluidIconKey["GLOBE"] = "globe";
    FluidIconKey["HIDDEN"] = "hidden";
    FluidIconKey["HISTORY"] = "history";
    FluidIconKey["IMAGE"] = "image";
    FluidIconKey["IMG_PREVIEW"] = "img_preview";
    FluidIconKey["INFO"] = "info";
    FluidIconKey["LIGHTBULB"] = "lightbulb";
    FluidIconKey["LINK"] = "link";
    FluidIconKey["LIST_OL"] = "list_ol";
    FluidIconKey["LIST_UL"] = "list_ul";
    FluidIconKey["LOADER"] = "loader";
    FluidIconKey["LOCATION"] = "location";
    FluidIconKey["LOCKED"] = "locked";
    FluidIconKey["MAP"] = "map";
    FluidIconKey["MEMO_CIRCLE_INFO"] = "memo_circle_info";
    FluidIconKey["MINUS"] = "minus";
    FluidIconKey["NEGOTIATED"] = "negotiated";
    FluidIconKey["NOTES"] = "notes";
    FluidIconKey["PENCIL"] = "pencil";
    FluidIconKey["PLUS"] = "plus";
    FluidIconKey["PRINT"] = "print";
    FluidIconKey["QUESTION"] = "question";
    FluidIconKey["REFRESH"] = "refresh";
    FluidIconKey["RESTORE"] = "restore";
    FluidIconKey["SAVE"] = "save";
    FluidIconKey["SEARCH"] = "search";
    FluidIconKey["SETTINGS"] = "settings";
    FluidIconKey["SHARE"] = "share";
    FluidIconKey["SHIELD"] = "shield";
    FluidIconKey["SORT_DOWN"] = "sort_down";
    FluidIconKey["SORT_UP"] = "sort_up";
    FluidIconKey["STAR"] = "star";
    FluidIconKey["STAR_OUTLINE"] = "star_outline";
    FluidIconKey["STAR_FILLED"] = "star_filled";
    FluidIconKey["STAR_HALF_FILLED"] = "star_half_filled";
    FluidIconKey["SUCCESS"] = "success";
    FluidIconKey["SUPPORT"] = "support";
    FluidIconKey["UNCHECK"] = "uncheck";
    FluidIconKey["UNDO"] = "undo";
    FluidIconKey["UNLINK"] = "unlink";
    FluidIconKey["UNLOCKED"] = "unlocked";
    FluidIconKey["UPDATED"] = "updated";
    FluidIconKey["UPLOAD"] = "upload";
    FluidIconKey["USER"] = "user";
    FluidIconKey["USER_ACCOUNT"] = "user_account";
    FluidIconKey["VISIBLE"] = "visible";
    FluidIconKey["WARNING"] = "warning";
    FluidIconKey["WRENCH"] = "wrench";
    // Frameworks / Platforms
    FluidIconKey["ANGULAR"] = "angular";
    FluidIconKey["JAVASCRIPT"] = "javascript";
    FluidIconKey["REACT"] = "react";
    FluidIconKey["SLACK"] = "slack";
    FluidIconKey["SVELTE"] = "svelte";
    FluidIconKey["TEAMS"] = "teams";
    FluidIconKey["VUE"] = "vue";
    FluidIconKey["YOUTUBE"] = "you_tube";
    // Flags
    FluidIconKey["AUSTRALIA"] = "australia";
    FluidIconKey["BELGIUM"] = "belgium";
    FluidIconKey["BRAZIL"] = "brazil";
    FluidIconKey["CANADA"] = "canada";
    FluidIconKey["CHILE"] = "chile";
    FluidIconKey["CHINA"] = "china";
    FluidIconKey["COLOMBIA"] = "colombia";
    FluidIconKey["ECUADOR"] = "ecuador";
    FluidIconKey["FRANCE"] = "france";
    FluidIconKey["GERMANY"] = "germany";
    FluidIconKey["HONG_KONG"] = "hong_kong";
    FluidIconKey["INDIA"] = "india";
    FluidIconKey["IRELAND"] = "ireland";
    FluidIconKey["ITALY"] = "italy";
    FluidIconKey["JAPAN"] = "japan";
    FluidIconKey["MALAYSIA"] = "malaysia";
    FluidIconKey["MEXICO"] = "mexico";
    FluidIconKey["PERU"] = "peru";
    FluidIconKey["PORTUGAL"] = "portugal";
    FluidIconKey["SINGAPORE"] = "singapore";
    FluidIconKey["SPAIN"] = "spain";
    FluidIconKey["THAILAND"] = "thailand";
    FluidIconKey["UNITED_KINGDOM"] = "uk";
    FluidIconKey["USA"] = "usa";
    FluidIconKey["VIETNAM"] = "vietnam";
})(FluidIconKey = exports.FluidIconKey || (exports.FluidIconKey = {}));
